import {Colors, Container} from "@bounce/shared";
import {Box} from "@mui/system";
import TuneIcon from "@mui/icons-material/Tune";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  onClick: () => void;
  onClose: () => void;
}

export const DevToolsWidget = ({onClick, onClose}: Props) => {
  return (
    <Container
      onClick={onClick}
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        bgcolor: Colors.bw.white,
        color: Colors.primary._800,
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: `1.5px solid ${Colors.primary._800}`,
        cursor: "pointer",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
      }}
    >
      <Box
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        sx={{
          position: "absolute",
          top: -5,
          right: -5,
          bgcolor: Colors.bw.white,
          color: Colors.primary._800,
          border: `1px solid ${Colors.primary._800}`,
          width: 16,
          height: 16,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          "&:hover": {
            bgcolor: Colors.primary._100,
          },
        }}
      >
        <CloseIcon sx={{fontSize: 11}} />
      </Box>
      <TuneIcon sx={{fontSize: 20, color: Colors.primary._800}} />
    </Container>
  );
};
